import * as React from "react";
import { Button, Modal } from "semantic-ui-react";

import { IsLoadingButton } from "@teamprevent/common/IsLoadingButton";
import { ConfirmedButton } from "@teamprevent/common/confirmedButton/ConfirmedButton";
import Utils from "@teamprevent/common/utils";

import { OrgStructuresModel } from "@teamprevent/common/orgStructure/models";

import { SAVE_CUSTOMERUSER } from "../actiontypes";

import { EditUnconnected, EditProps, DispatchProps } from "./Edit";

interface State {
    initialRoles: string[] | undefined;
    currentRoles: string[] | undefined;
    emailAddress: string | undefined;
    orgStructure: OrgStructuresModel | undefined;
    lockOrgLevelOneForCaseCreation: boolean;
}

export class EditModal extends React.Component<EditProps & DispatchProps, State> {
    constructor(props: EditProps & DispatchProps) {
        super(props);
        this.state = {
            initialRoles: undefined,
            currentRoles: undefined,
            emailAddress: undefined,
            orgStructure: undefined,
            lockOrgLevelOneForCaseCreation: false
        };

        this.onClose = this.onClose.bind(this);
        this.onRolesChanged = this.onRolesChanged.bind(this);
        this.getSaveButton = this.getSaveButton.bind(this);
        this.onEmailAddressChanged = this.onEmailAddressChanged.bind(this);
        this.onOrgStructuresChanged = this.onOrgStructuresChanged.bind(this);
        this.onLockOrgLevelOneForCaseCreationChanged = this.onLockOrgLevelOneForCaseCreationChanged.bind(this);
    }

    private editForm: EditUnconnected | null = null;

    public componentDidMount() {
        this.setState({
            initialRoles: this.props.model.roles,
            currentRoles: this.props.model.roles,
            emailAddress: this.props.model.emailAddress,
            orgStructure: {
                orgStructureOne: this.props.model.orgStructureOne,
                orgStructureTwo: this.props.model.orgStructureTwo,
                orgStructureThree: this.props.model.orgStructureThree,
                orgStructureFour: this.props.model.orgStructureFour
            },
            lockOrgLevelOneForCaseCreation: this.props.model.lockOrgLevelOneForCaseCreation
        });
    }

    public componentDidUpdate() {
        const hasStateBeenCleared = this.state.initialRoles === undefined && this.state.currentRoles === undefined;
        const customerUserLoaded = !!this.props.model?.roles;
        if (hasStateBeenCleared && customerUserLoaded) {
            this.setState({
                initialRoles: this.props.model.roles,
                currentRoles: this.props.model.roles,
                emailAddress: this.props.model.emailAddress,
                orgStructure: {
                    orgStructureOne: this.props.model.orgStructureOne,
                    orgStructureTwo: this.props.model.orgStructureTwo,
                    orgStructureThree: this.props.model.orgStructureThree,
                    orgStructureFour: this.props.model.orgStructureFour
                },
                lockOrgLevelOneForCaseCreation: this.props.model.lockOrgLevelOneForCaseCreation
            });
        }
    }

    public render() {
        const model = {
            ...this.props.model,
            roles: this.state.currentRoles ?? this.props.model?.roles,
            emailAddress: this.state.emailAddress ?? this.props.model?.emailAddress,
            orgStructureOne: this.state.orgStructure?.orgStructureOne,
            orgStructureTwo: this.state.orgStructure?.orgStructureTwo,
            orgStructureThree: this.state.orgStructure?.orgStructureThree,
            orgStructureFour: this.state.orgStructure?.orgStructureFour,
            lockOrgLevelOneForCaseCreation: this.state.lockOrgLevelOneForCaseCreation ?? this.props.model?.lockOrgLevelOneForCaseCreation
        };
        return (
            <Modal size="small" open={this.props.open} onClose={this.props.close} closeOnDimmerClick={false}>
                <Modal.Header>Edit Customer User</Modal.Header>
                <Modal.Content>
                    <EditUnconnected
                        open={this.props.open}
                        save={this.props.save}
                        model={model}
                        ref={instance => this.editForm = instance}
                        customer={this.props.customer}
                        orgStructures={this.props.orgStructures}
                        currentUser={this.props.currentUser}
                        customerSraDepartments={this.props.customerSraDepartments}
                        onRolesChanged={this.onRolesChanged}
                        close={this.props.close}
                        onEmailAddressChanged={this.onEmailAddressChanged}
                        loadOrgStructures={this.props.loadOrgStructures}
                        onOrgStructuresChanged={this.onOrgStructuresChanged}
                        onLockOrgLevelOneForCaseCreationChanged={this.onLockOrgLevelOneForCaseCreationChanged}
                        genericCaseTypes={this.props.genericCaseTypes}
                        loadGenericCaseTypes={this.props.loadGenericCaseTypes}
                    />
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={this.onClose}>Cancel</Button>
                    {this.getSaveButton()}
                </Modal.Actions>
            </Modal>
        );
    }

    private onClose() {
        this.setState({
            initialRoles: undefined,
            currentRoles: undefined,
            emailAddress: undefined,
            orgStructure: undefined,
            lockOrgLevelOneForCaseCreation: false
        }, () => this.props.close());
    }

    private onEmailAddressChanged(emailAddress: string) {
        this.setState({
            ...this.state,
            emailAddress
        });
    }

    private onRolesChanged(roles: string[]) {
        this.setState({
            ...this.state,
            currentRoles: roles,

        });
    }

    private onLockOrgLevelOneForCaseCreationChanged(value: boolean) {
        this.setState({
            ...this.state,
            lockOrgLevelOneForCaseCreation: value,
        });
    }

    private onOrgStructuresChanged(orgStructuresModel: OrgStructuresModel) {
        this.setState({
            ...this.state,
            orgStructure: orgStructuresModel
        });
    }

    private getSaveButton() {
        const haveRolesChanged = !Utils.IsStringArraysContentEqual(this.state.initialRoles, this.state.currentRoles);
        return haveRolesChanged
            ? (<ConfirmedButton
                content="Save"
                onClick={() => this.onSubmit()}
                promptText="Are you sure you want to edit this user? By changing the customer user's role,
                            you are removing them from any cases which they are associated with.
                            Do you wish to continue? Type 'EDIT' and click confirm to edit."
                typeToConfirmText="EDIT"
                headingText="Edit Customer User"
            />)
            : <IsLoadingButton requestNames={SAVE_CUSTOMERUSER} content="Save" onClick={this.onSubmit} />;
    }

    private onSubmit = () => {
        if (this.editForm) {
            this.editForm.submit();
        }
    };
}
